import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getClients } from "./actions";

export const clientEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = clientEntityAdapter.getInitialState({});

export const clientSlice = createSlice({
  name: "client",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClients.fulfilled, (state, action) => {
      if (action.payload.success) {
        clientEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default clientSlice.reducer;
